export default "__VITE_ASSET__BnFvZG_p__"